export default { sha: 'bf782bb9af872515c285fd59c49eb820c38b4a36', buildNumber: 'undefined' }
